/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { use } from 'fierry/react';

import Route from 'solis/route';
import Galaxy from 'solis/application/galaxy';

import Args from 'solis/claude/action/args';

import useTargetZone from 'solis/claude/action/target.zone';


// The action context for a colony pane: the colony in view (by route id), the selected
// target zone, and the current account.
export default () =>
{
  const route   = use(Route);
  const galaxy  = use(Galaxy);
  const colony  = galaxy.getColony(route.getArg('id'));
  const account = galaxy.getCurrentAccount();
  const zone    = useTargetZone(colony, Args.ColonyZone);

  return { colony, zone, account };
};
